export default __webpack_public_path__ + "static/media/pause.0332beaa.png";